// extracted by mini-css-extract-plugin
export default {"root":"Feed_root__LJE0X","loading":"Feed_loading__+Zbm0","error":"Feed_error__jht5r","empty":"Feed_empty__t9x8j","fetchMore":"Feed_fetchMore__GPXGX"};